import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { AppLoader } from '~/components/loader'
import { setLastOrgAlias } from '~/features/auth/utils'
import { DatastoreProvider } from '~/features/datastore'
import { UploadProvider } from '~/features/importer'
import { SignalingProvider } from '~/features/signaling'
import GlobalStyles from '~/globalStyles.styles'
import { useCurrentUser, useLegacyTheme } from '~/hooks'
import Loading, { LoadingProvider } from '~/modules/loader'

import { Dialog, DialogContent } from '@hap/components'

import { CompleteProfileGate } from './$alias/-components/complete-profile-gate'

export const Route = createFileRoute('/_authenticated/$alias')({
  component: RouteComponent,
})

function RouteComponent() {
  const { alias } = Route.useParams()
  const theme = useLegacyTheme()
  const currentUser = useCurrentUser()

  useEffect(() => {
    setLastOrgAlias(alias)
  }, [alias])
  const needsProfileCompletion = !!(
    currentUser &&
    (!currentUser.firstName?.trim() || !currentUser.lastName?.trim())
  )

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <DatastoreProvider>
        <LoadingProvider>
          <SignalingProvider>
            <UploadProvider>
              <Loading />
              {!currentUser ? (
                <AppLoader />
              ) : (
                <>
                  <Outlet />
                  <Dialog open={needsProfileCompletion}>
                    <DialogContent
                      onEscapeKeyDown={(event) => event.preventDefault()}
                      onPointerDownOutside={(event) => event.preventDefault()}
                      onInteractOutside={(event) => event.preventDefault()}
                      className="max-w-lg p-0"
                    >
                      <CompleteProfileGate
                        userId={currentUser.id}
                        firstName={currentUser.firstName || ''}
                        lastName={currentUser.lastName || ''}
                      />
                    </DialogContent>
                  </Dialog>
                </>
              )}
            </UploadProvider>
          </SignalingProvider>
        </LoadingProvider>
      </DatastoreProvider>
    </ThemeProvider>
  )
}
